import login from '@/http/requests/auth/login/index.js'
import checkout from '@/http/requests/checkout'
import payments from '@/http/requests/payments'
import adminRequests from '@/http/requests/admin'
import usetiful from '@/libs/usetiful'
import type from '@/auth/type'

export default {
  login: ({ commit }, payload) => new Promise((resolve, reject) => {
    login.login(payload)
      .then(response => {
        commit('SET_TOKEN', response.data)
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  }),
  logout: ({ commit }) => new Promise(resolve => {
    commit('REMOVE_USER_TOKEN')
    commit('REMOVE_USER_INFO')
    commit('SET_FETCHING_USER_INFO', false)
    commit('CLEAR_IMPERSONATION')

    caches.keys()
      .then(names => {
        for (let i = 0; i < names.length; i += 1) {
          const name = names[i]
          caches.delete(name)
        }
      })
    resolve(true)
  }),
  register: (_, payload) => new Promise((resolve, reject) => {
    login.register(payload.data)
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  }),
  registerInOrganization: (_, payload) => new Promise((resolve, reject) => {
    login.registerInOrganization(payload.organizationId, payload.data)
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  }),
  confirmRegistration: (_, payload) => new Promise((resolve, reject) => {
    login.confirmRegistration(payload)
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  }),
  forgotPassword: (_, email) => new Promise((resolve, reject) => {
    login.forgotPassword({ email })
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  }),
  changePassword: (_, payload) => new Promise((resolve, reject) => {
    login.resetPassword(payload.userId, payload)
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  }),
  fetchUserInfo: ({ commit, state }) => new Promise((resolve, reject) => {
    if (!state.fetchingUserInfo) {
      commit('SET_FETCHING_USER_INFO', true)
      login.userInfo()
        .then(res => {
          commit('SET_USER_INFO', res.data)
          usetiful.init()

          if (res.data.type === type.teacher) {
            // Start of Tawk.to Script
            window.Tawk_API = window.Tawk_API || {}
            window.Tawk_LoadStart = new Date()

            window.Tawk_API.onLoad = () => {
              window.Tawk_API.hideWidget()
              window.Tawk_API.minimize()
              window.Tawk_API.onChatMaximized = () => {
                this.$store.commit('app/UPDATE_CHAT_VISIBILITY', true)
              }
              window.Tawk_API.onChatMinimized = () => {
                this.$store.commit('app/UPDATE_CHAT_VISIBILITY', false)
              }

              window.Tawk_API.setAttributes({
                userId: res.data.id,
                organizationId: res.data.organization ? res.data.organization.id : null,
                email: res.data.email,
                name: `${res.data.firstName} ${res.data.lastName}`,
                // hash: res.data && res.data.organization && res.data.organization.hash,
              })
            };

            ((() => {
              const s1 = document.createElement('script')
              const s0 = document.getElementsByTagName('script')[0]
              s1.async = true
              s1.src = 'https://embed.tawk.to/68c16d5be24d4a1923ef38f7/1j4pp6big'
              s1.charset = 'UTF-8'
              s1.setAttribute('crossorigin', '*')
              s0.parentNode.insertBefore(s1, s0)
            })())
          }
          // End of Tawk.to Script

          resolve(res)
        })
        .catch(err => reject(err))
        .finally(() => {
          commit('SET_FETCHING_USER_INFO', false)
        })
    }
  }),
  fetchAccessTokenByRefreshToken: ({ commit }) => new Promise((resolve, reject) => {
    login.refreshToken()
      .then(response => {
        commit('SET_TOKEN', response.data)
        resolve(response)
      })
      .catch(err => reject(err))
  }),
  fetchNotifications: ({ commit }) => new Promise((resolve, reject) => {
    try {
      login.userNotifications()
        .then(response => {
          commit('SET_NOTIFICATIONS', response.data)
          resolve(response)
        })
    } catch (error) {
      reject(error)
    }
  }),
  impersonateUser: ({
    commit, dispatch, getters, state,
  }, userId) => new Promise((resolve, reject) => {
    if (state.impersonation) {
      reject(new Error('impersonation-already-active'))
      return
    }

    const impersonator = getters.getUser || {}

    adminRequests.startImpersonation(userId)
      .then(response => {
        commit('SET_IMPERSONATION', {
          impersonatorId: response.data.impersonatorId,
          impersonatedUserId: response.data.impersonatedUserId,
          impersonator: {
            id: impersonator.id,
            firstName: impersonator.firstName,
            lastName: impersonator.lastName,
            email: impersonator.email,
          },
          startedAt: new Date().toISOString(),
        })
        commit('SET_TOKEN', response.data)
        dispatch('fetchUserInfo')
          .then(res => resolve(res))
          .catch(error => reject(error))
      })
      .catch(error => {
        reject(error)
      })
  }),
  revertImpersonation: ({ commit, dispatch, state }) => new Promise((resolve, reject) => {
    if (!state.impersonation) {
      resolve()
      return
    }

    adminRequests.revertImpersonation()
      .then(response => {
        commit('SET_TOKEN', response.data)
        commit('CLEAR_IMPERSONATION')
        dispatch('fetchUserInfo')
          .then(res => resolve(res))
          .catch(error => reject(error))
      })
      .catch(error => {
        reject(error)
      })
  }),
  markNotificationAsRead: (_, id) => new Promise((resolve, reject) => {
    login.markNotificationAsRead(id)
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  }),
  prepareRedirectUrl: (_, payload) => new Promise((resolve, reject) => {
    checkout.createCheckoutSession(payload)
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  }),
  createPortalSession: () => new Promise((resolve, reject) => {
    payments.createPortalSession()
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  }),
  retryPayment: () => new Promise((resolve, reject) => {
    payments.retryPayment()
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  }),
}
